import { filter, get, isEmpty } from 'lodash'
import * as Yup from 'yup'
declare module 'yup' {
  interface ArraySchema<T> {
    uniqueKeywordProperty(
      propertyPath: string,
      message?: string
    ): ArraySchema<T>
  }
}

Yup.addMethod(
  Yup.array,
  'uniqueKeywordProperty',
  function (propertyPath, message) {
    return this.test('unique', '', function (list: any) {
      const errors: any = []

      list?.forEach((item: any, index: number) => {
        const propertyValue = get(item, propertyPath)
        if (
          propertyValue &&
          filter(list, [propertyPath, propertyValue]).length > 1
        ) {
          errors.push(
            this.createError({
              path: `${this.path}`,
              message,
            })
          )
        }
      })

      if (!isEmpty(errors)) {
        throw new Yup.ValidationError(errors)
      }

      return true
    })
  }
)

const KeywordCompetitorValidation = Yup.object().shape({
  keywordCompetitorMapping: Yup.array()
    .of(
      Yup.object().shape({
        keywords: Yup.array()
          .of(
            Yup.object().shape({
              name: Yup.string(),
            })
          )
          .uniqueKeywordProperty('name', 'keyword name must be unique')
          .min(1, 'At least one keyword is required')
          .required('At least one keyword is required'),
        competitors: Yup.array()
          .min(1, 'At least one competitor is required')
          .max(5, 'Maximum 5 competitors allowed per keyword')
          .required('At least one competitor is required'),
      })
    )
    .max(5, 'Maximum 5 keyword tracking sections allowed'),
})

export default KeywordCompetitorValidation
